import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Icon,
  Image,
  Alert,
} from '@chakra-ui/react';
import { FaCog } from 'react-icons/fa';

const ComingSoonSection = ({ 
  title = 'Próximamente', 
  message = 'Esta funcionalidad estará disponible muy pronto',
  features = [],
}) => (
  <VStack gap={8} py={12}>
    <Box position="relative">
      <Image
        src="/capirote-mantenimiento.png"
        alt="Próximamente"
        maxW="150px"
        css={{
          '& @keyframes float': {
            '0%, 100%': { transform: 'translateY(0px)' },
            '50%': { transform: 'translateY(-20px)' }
          },

          animation: 'float 3s ease-in-out infinite'
        }}
      />
      <Box
        position="absolute"
        top="-10px"
        right="-10px"
        css={{
          '& @keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' }
          },

          animation: 'spin 3s linear infinite'
        }}
      >
        <Icon boxSize={10} color="purple.400" asChild><FaCog /></Icon>
      </Box>
      <Box
        position="absolute"
        bottom="0"
        left="-20px"
        css={{
          '& @keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' }
          },

          animation: 'spin 4s linear infinite reverse'
        }}
      >
        <Icon boxSize={7} color="gold.400" asChild><FaCog /></Icon>
      </Box>
    </Box>

    <VStack gap={4} textAlign="center" maxW="xl">
      <Heading size="xl" color="purple.600">{title}</Heading>
      <Text fontSize="lg" color="gray.600">{message}</Text>
      <Text fontSize="md" color="gray.500">
        Te avisaremos por email cuando esta sección esté lista.
      </Text>
    </VStack>

    {features.length > 0 && (
      <Alert.Root status="info" rounded="xl" shadow="sm" maxW="xl">
        <Alert.Indicator />
        <Box>
          <Text fontWeight="bold">¿Qué incluirá?</Text>
          <Text fontSize="sm" mt={2}>
            {features.map((f, i) => (
              <React.Fragment key={i}>• {f}{i < features.length - 1 && <br />}</React.Fragment>
            ))}
          </Text>
        </Box>
      </Alert.Root>
    )}
  </VStack>
);

export default ComingSoonSection;
